function PlayerSeasonSnapshot({
 selectedTeamFilter,
 primaryTeam,
 gamesPlayed,
 totalPTS,
 totalFTM,
 totalFTA,
 total3PM,
}) {
 const snapshotStats = [
  {
   key: "points",
   label: "Total Points",
   value: totalPTS,
  },
  {
   key: "ftm",
   label: "FT Made",
   value: totalFTM,
  },
  {
   key: "fta",
   label: "FT Attempted",
   value: totalFTA,
  },
  {
   key: "threeMade",
   label: "3PT Made",
   value: total3PM,
  },
 ];

 return (
  <div className="profile-card season-card">
   <div className="card-header">
    <h3>Current Season Snapshot</h3>


   </div>

   <div className="snapshot-grid">
    {snapshotStats.map((stat) => (
     <div key={stat.key}>
      <p>{stat.label}</p>
      <strong>{stat.value}</strong>
      {stat.subtitle && <span>{stat.subtitle}</span>}
     </div>
    ))}
   </div>

   <small className="note">
    ● Stats reflect {gamesPlayed} games in this view
   </small>
  </div>
 );
}

export default PlayerSeasonSnapshot;